/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const GET_PRICE = "GET_PRICE";
export const SET_PRICE = "SET_PRICE";

export const GET_SKU = "GET_SKU";
export const SET_SKU = "SET_SKU";

export const SAVE_REQUESTED_RECIPE = "SAVE_REQUESTED_RECIPE";
export const RESET_ITEMS_TO_PURCHASE = "RESET_ITEMS_TO_PURCHASE";
export const SAVE_ITEM_SIZE = "SAVE_ITEM_SIZE";
export const SAVE_ITEM_QUANTITY = "SAVE_ITEM_QUANTITY";

export const SET_UGC_SIZE = "SET_UGC_SIZE";
export const SET_IS_UGC_APPLIED = "SET_IS_UGC_APPLIED";
export const REPLACE_SIZE_SELECTED = "REPLACE_SIZE_SELECTED";

export const SET_STORED_RECIPES = "SET_STORED_RECIPES";
export const RESET_STORED_RECIPES = "RESET_STORED_RECIPES";
export const STORE_A_RECIPE = "STORE_A_RECIPE";

export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";

export const GET_SIZE_GUIDE_MODAL_CONTENT = "GET_SIZE_GUIDE_MODAL_CONTENT";
export const SET_SHOW_SHARE_TO_PURCHASE = "SET_SHOW_SHARE_TO_PURCHASE";
export const SET_CART_IMAGE = "SET_CART_IMAGE";

// CANVAS
export const ADD_TO_CART_CANVAS = "ADD_TO_CART_CANVAS";
export const FETCH_BASKET_ID = "FETCH_BASKET_ID";
